export const ProductAmountSourceMap = {
  borrower_amount_override: 'Borrower Amount Override',
  fee_mgmt_override: 'Fee Override',
  legacy_vendor_geo_override: 'Vendor Geographic Override',
  appraiser_override: 'Vendor Override',
  legacy_geo_override: 'Geographic Override',
  disclosed_amount_cap_applied: 'Disclosed Amount Cap Applied',
  integration_fee_applied: 'Integration Override',
  base_product_amount: 'Base Product Amount',
  manual_fee_override_exists: 'Manual Fee Override',
}
